<div class="toast-container"><toast *ngFor="let toast of toasts$ | async" [toast]="toast" [@ngIfAnimation]></toast></div>